import tippy from "tippy.js";
import { select } from "../shared/utils/dom";

export default function downloadUsageHistory() {
  const el = select('[data-vue-app="usage-history"]');
  const alertCurrent = select("#alert-NoCurrentYearUsageData");
  const alertPrevious = select("#alert-NoPreviousYearUsageData");

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      // eslint-disable-line no-new
      el,
      methods: {
        showNoPreviousUsageData() {
          if (alertCurrent && !alertCurrent.classList.contains('hidden')) {
            alertCurrent.classList.add("hidden");
          }

          if (alertPrevious && alertPrevious.classList.contains("hidden")) {
            alertPrevious.classList.remove("hidden");
          }

          this.closeTooltip();
        },
        showNoCurrentUsageData() {
          if (alertCurrent && alertCurrent.classList.contains("hidden")) {
            alertCurrent.classList.remove("hidden");
          }

          if (alertPrevious && !alertPrevious.classList.contains("hidden")) {
            alertPrevious.classList.add("hidden");
          }

          this.closeTooltip();
        },
        downloadCsv(url) {
          if (alertCurrent && !alertCurrent.classList.contains("hidden")) {
            alertCurrent.classList.add("hidden");
          }

          if (alertPrevious && !alertPrevious.classList.contains("hidden")) {
            alertPrevious.classList.add("hidden");
          }

          window.location.replace(url);
          this.closeTooltip();
        },
        closeTooltip() {
          select(".download-usage-history")._tippy.hide();
        },
      },
    });
  }

  const downloadButton = select(".download-usage-history");
  const content = select('#usage-history');
  tippy(downloadButton, {
    arrow: true,
    flip: true,
    html: content,
    theme: "nisource",
    trigger: "click",
    placement: "bottom",
    zIndex: 90,
    interactive: true,
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/downloadHistory.js